import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { ConfigService } from '../../shared-services/config.service';
import { CommonModule } from '@angular/common';
import { GlobalFilterService } from '../../shared-services/global-filter-service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { auditTime, filter, Subject } from 'rxjs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { GlobalService } from '../../shared-services/global.service';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-table',
  imports: [MatTableModule, CommonModule, MatProgressSpinnerModule, MatIconModule],
  standalone: true,
  templateUrl: './table.component.html',
  styleUrl: './table.component.scss',
})
export class TableComponent implements AfterViewInit {
  @Input() data!: any;
  displayedColumns: string[] = [];
  filters: any;
  isLoading = true;
  columnLabels: { [key: string]: string } = {};
  dataSource: any[] = [];
  isWaitingForScenarios = false;
  loadingText = '';

  private destroy$ = new Subject<void>();
  private unSubscribe$: Subject<void> = new Subject();
  @Input() set widgetId(val: string) {
    this._widgetId = val;
  }
  get widgetId(): string {
    return this._widgetId || this.data?.widgetId;
  }
  private _widgetId!: string;

  constructor(
    private configService: ConfigService,
    private globalService: GlobalService, 
    private globalFilterService: GlobalFilterService
  ) {}

  ngAfterViewInit() {
    // Listen for scenario generation events
    this.globalService.scenarioGeneration$.pipe(takeUntil(this.destroy$)).subscribe(scenarioPayload => {
      if (this.widgetId === 'widgetTableBelow') {
        this.isWaitingForScenarios = false;
        console.log('Table widget received scenario payload:', scenarioPayload);
        const currentGlobalFilters = this.globalService.getCurrentFilters().filter;
        const combinedFilters = { ...currentGlobalFilters, ...scenarioPayload };
        this.loadAndRenderChart(combinedFilters, true);
      }
    });

    if (!this.data.ignoreGlobalFilters) {
      // If not ignoring, subscribe to global filters for initial load and updates
      this.globalService.filters$
        .pipe(
          auditTime(50),
          filter((filters) => !!filters),
          takeUntil(this.destroy$)
        )
        .subscribe((filters) => {
          this.filters = { ...filters.filter };
          this.loadAndRenderChart(this.filters, false);
        });
    } else {
      // If ignoring global filters, just show the initial message and wait
      this.isWaitingForScenarios = true;
      this.isLoading = false;
    }
  }

  private loadAndRenderChart(filters?: any, isScenario = false): void {
    console.log('Loading table data with filters:', filters);
    this.loadingText = isScenario ? 'Simulating data...' : '';
    this.isLoading = true;
    const method = (this.data?.method || 'post').toLowerCase();
this.configService
  .getConfig(this.data.apiUrl, filters, method, true)
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe({
        next: (res: any) => {
          let tableData = res?.options || [];
          this.isLoading = false;
          this.dataSource = tableData;

          this.displayedColumns =
            this.data?.headerColumns?.map((col: any) => col.key) || [];
          this.columnLabels = Object.fromEntries(
            this.data?.headerColumns?.map((col: any) => [col.key, col.label]) ||
              []
          );
        },
        error: (err) => {
          this.isLoading = false;
          console.error('Error loading table data', err);
        },
      });
  }
    ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
    this.destroy$.next();
    this.destroy$.complete();
  }
}
